// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5853":"css/app.6907","6829":"css/admin-app.6907"}[chunkId] + ".css";
};